import JWTContainer from "../models/JWTContainer";
export default class SessionContainer {
    get apiEngine() {
        if (!this._apiEngine)
            throw "No API engine set";
        return this._apiEngine;
    }
    set apiEngine(value) {
        this._apiEngine = value;
    }
    constructor(_userClassAsObject, _meUrl) {
        this._apiEngine = null;
        this.meUrl = _meUrl;
        this._currentUser = null;
        this.userClassAsObject = _userClassAsObject;
        this.jwtContainer = JWTContainer.tryToRestoreJWT();
        this.updateToken = this.updateToken.bind(this);
        this.refresh = this.refresh.bind(this);
    }
    updateToken(_token) {
        localStorage.setItem("jwt", _token);
        let csrfString = localStorage.getItem("csrf");
        localStorage.setItem("csrf", csrfString ? csrfString : "");
        this.jwtContainer = JWTContainer.tryToRestoreJWT();
    }
    refresh() {
        this.jwtContainer = JWTContainer.tryToRestoreJWT();
    }
    get currentEntity() {
        if (!this._currentUser)
            throw "No user";
        return this._currentUser;
    }
    set currentEntity(value) {
        this._currentUser = value;
    }
    get currentUser() {
        return this._currentUser;
    }
    set currentUser(value) {
        this._currentUser = value;
    }
    set jwtContainer(value) {
        this._jwtContainer = value;
        if (this._jwtContainer) {
            // alert(123);
            this._jwtContainer.writeToLocalStorage();
        }
    }
    get jwtContainer() {
        return this._jwtContainer;
    }
    checkUser() {
        let me = this;
        if (!me.apiEngine)
            throw new Error("Не задан API Engine");
        console.log("checkUser");
        return new Promise((resolve, reject) => {
            if (!me._jwtContainer) {
                console.error("No JWT");
                reject("No JWT");
                return;
            }
            console.log("Sending request");
            me.apiEngine.asyncFetch(me.meUrl, {}).then((e) => {
                console.log("Sending request");
                if (!e) {
                    console.error("Empty answer");
                    reject("Empty answer");
                    return;
                }
                if (e || me._jwtContainer) {
                    // me._currentUser = (new me.userClassAsObject(e.uuid)) as UserClass;
                    console.log("Setting user");
                    try {
                        me._currentUser = (new me.userClassAsObject(e));
                        resolve(me._currentUser);
                    }
                    catch (e) {
                        reject(e);
                    }
                    // alert(JSON.stringify(e));
                }
                else {
                    console.error("Answering error");
                    reject(false);
                }
            }, (e) => {
                console.error("Something went wrong");
                if (me._jwtContainer)
                    me._jwtContainer.revoke();
                reject(e);
            });
        });
    }
}
